import React, { Component } from "react";

import Render from "./Render";
import { Auth } from "redux-server-connection";

class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
  }

  // This keeps your state in sync with the opening/closing of the menu
  // via the default means, e.g. clicking the X, pressing the ESC key etc.
  handleStateChange (state) {
    this.setState({menuOpen: state.isOpen})  
  }
  
  // This can be used to close the menu, e.g. when a user clicks a menu item
  closeMenu () {
    this.setState({menuOpen: false})
  }

  // This can be used to toggle the menu, e.g. when using a custom icon
  // Tip: You probably want to hide either/both default icons if using a custom icon
  // See https://github.com/negomi/react-burger-menu#custom-icons
  toggleMenu () {
    this.setState(state => ({menuOpen: !state.menuOpen}))
  }
  
  logout() {
    Auth.logout();
  }

  render() {
    return <Render {...this.props} 
              logout={this.logout} closeMenu="{this.closeMenu}" toggleMenu="{this.toggleMenu}" 
            />;
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js